import { render, staticRenderFns } from "./FreeTimeSavingMobile.vue?vue&type=template&id=b135af96&"
import script from "./FreeTimeSavingMobile.vue?vue&type=script&lang=js&"
export * from "./FreeTimeSavingMobile.vue?vue&type=script&lang=js&"
import style0 from "./FreeTimeSavingMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports